export default function Stats(){

    return (
        <div className="max-w-[1440px] mx-auto lg:px-[80px] px-[16px] lg:py-[96px] py-[64px] relative">
            <div className="max-w-[768px] mx-auto text-center">
                <div className="h-[48px] w-[48px] mx-auto rounded-full bg-secondary-green-500/20 flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M6.09436 11.2288C6.03221 10.8282 5.99996 10.4179 5.99996 10C5.99996 5.58172 9.60525 2 14.0526 2C18.4999 2 22.1052 5.58172 22.1052 10C22.1052 10.9981 21.9213 11.9535 21.5852 12.8345C21.5154 13.0175 21.4804 13.109 21.4646 13.1804C21.4489 13.2512 21.4428 13.301 21.4411 13.3735C21.4394 13.4466 21.4493 13.5272 21.4692 13.6883L21.8717 16.9585C21.9153 17.3125 21.9371 17.4895 21.8782 17.6182C21.8266 17.731 21.735 17.8205 21.6211 17.8695C21.4911 17.9254 21.3146 17.8995 20.9617 17.8478L17.7765 17.3809C17.6101 17.3565 17.527 17.3443 17.4512 17.3448C17.3763 17.3452 17.3245 17.3507 17.2511 17.3661C17.177 17.3817 17.0823 17.4172 16.893 17.4881C16.0097 17.819 15.0524 18 14.0526 18C13.6344 18 13.2237 17.9683 12.8227 17.9073M7.63158 22C10.5965 22 13 19.5376 13 16.5C13 13.4624 10.5965 11 7.63158 11C4.66668 11 2.26316 13.4624 2.26316 16.5C2.26316 17.1106 2.36028 17.6979 2.53955 18.2467C2.61533 18.4787 2.65322 18.5947 2.66566 18.6739C2.67864 18.7567 2.68091 18.8031 2.67608 18.8867C2.67145 18.9668 2.65141 19.0573 2.61134 19.2383L2 22L4.9948 21.591C5.15827 21.5687 5.24 21.5575 5.31137 21.558C5.38652 21.5585 5.42641 21.5626 5.50011 21.5773C5.5701 21.5912 5.67416 21.6279 5.88227 21.7014C6.43059 21.8949 7.01911 22 7.63158 22Z" stroke="#6BCB77" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <h2 className="text-[#101828] lg:text-[36px] text-[30px] lg:leading-[44px] leading-[38px] font-[600] mt-[24px]">
                    {`Unleash the full power of data`}
                </h2>
                <p className="mt-[20px] text-[20px] text-[#475467] leading-[30px] font-[300]">
                    {`Everything you need to convert, engage, and retain more users.`}
                </p>
            </div>
            <div className="max-w-[768px] mx-auto text-center mt-[64px]">
                <div className="grid md:grid-cols-3 grid-cols-1 space-y-8">
                    <div className="text-center">
                        <h1 className="text-primary-blue-500 lg:text-[60px] text-[48px] lg:leading-[72px] leading-[60px] font-[600] mb-[12px]">
                            400+
                        </h1>
                        <span className="text-[18px] text-[#101828] leading-[28px] font-[600]">
                            Projects completed
                        </span>
                    </div>
                    <div className="text-center md:border-x">
                        <h1 className="text-primary-blue-500 lg:text-[60px] text-[48px] lg:leading-[72px] leading-[60px] font-[600] mb-[12px]">
                            400+
                        </h1>
                        <span className="text-[18px] text-[#101828] leading-[28px] font-[600]">
                            Projects completed
                        </span>
                    </div>
                    <div className="text-center">
                        <h1 className="text-primary-blue-500 lg:text-[60px] text-[48px] lg:leading-[72px] leading-[60px] font-[600] mb-[12px]">
                            400+
                        </h1>
                        <span className="text-[18px] text-[#101828] leading-[28px] font-[600]">
                            Projects completed
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}